import Panel from 'shared/components/Panel/Panel'
import { FeatureFlag } from 'shared/enums/FeatureFlag'
import { CheckoutQA } from 'shared/dataAttributes'
import { OrderSummary } from 'checkout/panels/OrderSummary/OrderSummary'
import { OrderSummaryContextProvider } from 'checkout/containers/OrderSummaryContextProvider'
import { t } from 'localization'
import { useFeatureFlag } from 'featureFlags/hooks/useFeatureFlag'

const TP = 'checkout.panels.OrderSummary.OrderSummaryPanel'

type OrderSummaryPanelProps = {
  className?: string
  wantId?: number
}

export const OrderSummaryPanel = ({ className, wantId }: OrderSummaryPanelProps) => {
  const isOffersEnabled = useFeatureFlag(FeatureFlag.TEMP_WEB_FC_ENABLE_OFFERS)

  const title =
    isOffersEnabled && wantId
      ? t(`${TP}.titleOffer`, 'offer summary')
      : t(`${TP}.title`, 'order summary')

  return (
    <Panel title={title} qaAttr={CheckoutQA.OrderSummary} className={className}>
      <OrderSummaryContextProvider>
        <OrderSummary />
      </OrderSummaryContextProvider>
    </Panel>
  )
}
